<template>
  <div id="inscripcion-app">
    <!-- <h4>{{$t('titles.form')}}</h4> -->
    <div id="inscripcion">
      <!--
        <h2 id="title">{{$t('titles.join')}}</h2>
        <div id="top-description">
          <h3>{{$t('inscription-top-description.title')}}</h3>
          <div class="description">
            <p>{{$t('inscription-top-description.part1')}}</p>
            <p>{{$t('inscription-top-description.part2')}}</p>
            <p>{{$t('inscription-top-description.part3')}}</p>
            <p>{{$t('inscription-top-description.part4')}}</p>
            <p>{{$t('inscription-top-description.part5')}}</p>
          </div>
        </div>
        -->
      <v-container fluid grid-list-md>
        <v-layout row wrap>
          <!-- <div class="box" v-if="!form_completed"> -->
          <div class="box">
            <h3 :style="cssProps">{{ $t("params.club_information") }}</h3>

            <div class="item">
              <label
                >{{ $t("params.club_name") }} <span class="obligatory">*</span>
              </label>
              <label class="obligatory" v-if="error.club.name">{{
                $t(error.club.name)
              }}</label>
              <input
                class="upper shadow"
                v-bind:class="error.club.name ? 'error' : ''"
                type="text"
                v-model="club.name"
                autocomplete="new-text"
              />
            </div>

            <div class="item">
              <label
                >{{ $t("params.address") }} <span class="obligatory">*</span>
              </label>
              <input
                class="shadow"
                v-bind:class="error.club.address ? 'error' : ''"
                type="text"
                v-model="club.address"
                autocomplete="new-text"
              />
            </div>

            <div class="item">
              <label>{{ $t("params.cp") }}</label>
              <input
                class="shadow"
                type="number"
                v-model="club.cp"
                autocomplete="new-text"
              />
            </div>

            <div class="item">
              <label
                >{{ $t("params.state") }} <span class="obligatory">*</span>
              </label>
              <input
                class="shadow"
                v-bind:class="error.club.state ? 'error' : ''"
                type="text"
                v-model="club.state"
                autocomplete="new-text"
              />
            </div>

            <div class="item">
              <label
                >{{ $t("params.country") }} <span class="obligatory">*</span>
              </label>
              <v-autocomplete
                :class="error.club.country ? 'error' : ''"
                v-model="club.country_id"
                :items="Object.values(countries)"
                item-text="name"
                item-value="id"
                no-data
                :browser-autocomplete="'asd2saS<'"
                hide-no-data
              >
              </v-autocomplete>
            </div>

            <div class="item">
              <label>{{ $t("params.city") }}</label>
              <input
                class="shadow"
                type="text"
                v-model="club.city"
                autocomplete="new-text"
              />
            </div>

            <div class="item">
              <label
                >{{ $t("params.phone") }}
                <span class="obligatory" v-if="error.club.invalit_phone">
                  {{ $t("errors.phone") }}</span
                >
              </label>
              <vue-tel-input
                v-model="club.phone"
                @input="clubPhone"
                autocomplete="new-text"
                style="border: none"
                :placeholder="''"
                defaultCountry="ES"
                :inputOptions="{ showDialCode: true }"
              ></vue-tel-input>
            </div>

            <div class="item">
              <label
                >{{ $t("params.mobile") }} <span class="obligatory">*</span>
                <span class="obligatory" v-if="error.club.invalit_mobile">
                  {{ $t("errors.phone") }}</span
                >
              </label>
              <vue-tel-input
                v-model="club.mobile"
                @input="clubMobile"
                :class="error.club.mobile ? 'error' : ''"
                :placeholder="''"
                autocomplete="new-text"
                style="border: none"
                defaultCountry="ES"
                :inputOptions="{ showDialCode: true }"
              ></vue-tel-input>
            </div>

            <div class="item">
              <label
                >{{ $t("params.email") }} <span class="obligatory">*</span>
                <span class="obligatory" v-if="error.club.invalit_email">
                  {{ $t("errors.email") }}</span
                >
              </label>
              <input
                class="shadow"
                v-bind:class="error.club.email ? 'error' : ''"
                type="email"
                v-model="club.email"
                autocomplete="new-text"
              />
            </div>

            <div class="item">
              <label>{{ $t("params.web") }}</label>
              <input
                class="shadow"
                type="text"
                v-model="club.web"
                autocomplete="new-text"
              />
            </div>

            <hr />

            <h3 :style="cssProps">
              {{ $t("titles.responsible_information2") }}
            </h3>

            <div class="item">
              <label
                >{{ $t("params.name") }} <span class="obligatory">*</span>
              </label>
              <input
                class="shadow upper"
                v-bind:class="error.contact.name ? 'error' : ''"
                type="text"
                v-model="contact.name"
                autocomplete="new-text"
              />
            </div>

            <div class="item">
              <label
                >{{ $t("params.surname") }} <span class="obligatory">*</span>
              </label>
              <input
                class="shadow upper"
                v-bind:class="error.contact.surname ? 'error' : ''"
                type="text"
                v-model="contact.surname"
                autocomplete="new-text"
              />
            </div>

            <div class="item">
              <label
                >{{ $t("params.job") }} <span class="obligatory">*</span>
              </label>
              <select
                class="shadow"
                v-bind:class="error.contact.position ? 'error' : ''"
                v-model="contact.position"
                autocomplete="new-text"
              >
                <option
                  v-for="type in contact_type"
                  v-bind:value="type.id"
                  v-bind:key="type.id"
                >
                  {{ $t(type.name) }}
                </option>
              </select>
            </div>

            <div class="item">
              <label
                >{{ $t("params.phone") }} <span class="obligatory">*</span>
                <span class="obligatory" v-if="error.contact.invalit_phone">
                  {{ $t("errors.phone") }}</span
                >
              </label>
              <vue-tel-input
                v-model="contact.phone"
                @input="contactPhone"
                :class="error.contact.phone ? 'error' : ''"
                :placeholder="''"
                autocomplete="new-text"
                style="border: none"
                defaultCountry="ES"
                :inputOptions="{ showDialCode: true }"
              ></vue-tel-input>
            </div>

            <div class="item">
              <label
                >{{ $t("params.mobile") }} <span class="obligatory">*</span>
                <span class="obligatory" v-if="error.contact.invalit_mobile">
                  {{ $t("errors.phone") }}</span
                >
              </label>
              <vue-tel-input
                v-model="contact.mobile"
                @input="contactMobile"
                :class="error.contact.mobile ? 'error' : ''"
                :placeholder="''"
                autocomplete="new-text"
                style="border: none"
                defaultCountry="ES"
                :inputOptions="{ showDialCode: true }"
              ></vue-tel-input>
            </div>

            <div class="item">
              <label
                >{{ $t("params.email") }} <span class="obligatory">*</span>
                <span class="obligatory" v-if="error.contact.invalit_email">
                  {{ $t("errors.email") }}</span
                >
              </label>
              <input
                class="shadow"
                v-bind:class="error.contact.email ? 'error' : ''"
                type="email"
                v-model="contact.email"
                autocomplete="new-text"
              />
            </div>

            <div class="item">
              <label
                >{{ $t("params.communication") }}
                <span class="obligatory">*</span>
              </label>
              <v-radio-group
                v-model="contact.language"
                row
                autocomplete="new-text"
              >
                <v-radio
                  v-for="language in languages"
                  v-bind:value="language.id"
                  v-bind:key="language.id"
                >
                  <template v-slot:label>
                    <span
                      v-bind:class="error.contact.language ? 'obligatory' : ''"
                    >
                      {{ language.name }}
                    </span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>

            <div class="item"></div>

            <hr />

            <h3 :style="cssProps">{{ $t("params.team_information") }}</h3>
            <div
              class="alert teams"
              v-if="team_total > 0"
              v-html="$tc('descriptions.team_alert', team_total, { n: team_total })"
            ></div>
            <div class="alert teams" v-else>
              {{ $t("descriptions.team_alert_empty") }}
            </div>

            <label
              >{{ $t("titles.categories") }} <span class="obligatory">*</span>
            </label>
            <div class="item categories">
              <div
                v-for="category in teams.category_types"
                v-bind:key="category.id"
              >
                <div
                  v-if="
                    category.max_age == 'INTEGRA' &&
                    (category.gender == 1 || category.gender == 3)
                  "
                >
                  <v-checkbox
                    color="green"
                    class="text"
                    v-model="category.checked"
                    v-bind:value="category.checked"
                  >
                    <template v-slot:label>
                      <span
                        v-bind:class="
                          error.teams.categories ? 'obligatory' : ''
                        "
                        >{{ category.max_age }}
                      </span>
                    </template>
                  </v-checkbox>
                  <div class="teams">
                    <span
                      v-if="category.checked"
                      class="teams_number_description"
                      >{{ $t("descriptions.teams_number") }}
                      {{ category.max_age }}:
                    </span>
                    <input
                      v-if="category.checked"
                      class="teams_number"
                      v-bind:class="category.error ? 'error' : ''"
                      type="number"
                      min="1"
                      pattern="[0-9]"
                      v-model="category.teams"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div class="item categories"></div>

            <!-- <div class="item"> -->
            <!-- <label
                >{{ $t("titles.modality") }} <span class="obligatory">*</span>
              </label>
              <v-radio-group v-model="teams.modality" row>
                <v-radio value="true">
                  <template v-slot:label>
                    <span
                      v-bind:class="error.teams.modality ? 'obligatory' : ''"
                      >1 - {{ $t("params.accommodation") }}</span
                    >
                  </template>
                </v-radio>
                <v-radio label="2. Sense Allotjament" value="false">
                  <template v-slot:label>
                    <span
                      v-bind:class="error.teams.modality ? 'obligatory' : ''"
                      >2 - {{ $t("params.no_accommodation") }}</span
                    >
                  </template>
                </v-radio>
              </v-radio-group> -->
            <!-- </div> -->

            <div class="item">
              <label
                >{{ $t("params.how_meet") }} <span class="obligatory">*</span>
              </label>
              <select
                class="shadow"
                v-bind:class="error.teams.how_meet ? 'error' : ''"
                v-model="teams.how_meet"
              >
                <option
                  v-for="type in how_meet"
                  v-bind:value="type.id"
                  v-bind:key="type.id"
                >
                  {{ $t(type.name) }}
                </option>
              </select>
            </div>
            <div class="item"></div>

            <hr />

            <h3 :style="cssProps">{{ $t("titles.terms_and_conditions") }}</h3>

            <div>
              <div>
                <v-checkbox v-model="information" class="terms_and_conditions">
                  <template v-slot:label>
                    <span> {{ $t("descriptions.information") }} </span>
                  </template>
                </v-checkbox>
                <button
                  v-if="true || event_type != 'MICBasketball'"
                  class="information"
                  v-on:click="openDialog()"
                >
                  {{ $t("more_information") }}
                </button>
              </div>

              <div>
                <v-checkbox
                  v-model="terms_and_conditions"
                  class="terms_and_conditions"
                >
                  <template v-slot:label>
                    <span
                      v-bind:class="
                        error.terms_and_conditions ? 'obligatory' : ''
                      "
                    >
                      {{ $t("descriptions.terms_and_conditions_1") }}
                      <a target="_blank" :href="terms_and_conditions_link">{{
                        $t("descriptions.terms_and_conditions_2")
                      }}</a>
                      {{ $t("descriptions.terms_and_conditions_1") }}
                      <a target="_blank" :href="tournament_rules_link">{{
                        $t("descriptions.terms_and_conditions_4")
                      }}</a>
                    </span>
                  </template>
                </v-checkbox>
              </div>

              <div>
                <v-checkbox
                  v-model="privacy_policy"
                  class="terms_and_conditions"
                >
                  <template v-slot:label>
                    <span
                      v-bind:class="
                        error.terms_and_conditions ? 'obligatory' : ''
                      "
                    >
                      {{ $t("descriptions.privacy_policy_1") }}
                      <a target="_blank" :href="privacy_policy_link">{{
                        $t("descriptions.privacy_policy_2")
                      }}</a>
                    </span>
                  </template>
                </v-checkbox>
                <button
                  v-if="true || event_type != 'MICBasketball'"
                  class="information"
                  v-on:click="openDialog()"
                >
                  {{ $t("more_information") }}
                </button>
              </div>

              <span v-if="error.recaptcha" class="obligatory"
                >* {{ $t("errors.recaptcha") }}</span
              >

              <!-- <div class="g-recaptcha" :data-sitekey="captcha_key"></div> -->
              <vue-recaptcha
                :sitekey="captcha_key"
                @verify="recaptcha = true"
                :loadRecaptchaScript="true"
              ></vue-recaptcha>
            </div>

            <div>
              <span class="obligatory error-form" v-if="error.form">{{
                $t("errors.form")
              }}</span>
            </div>

            <button
              :style="cssButton"
              type="button"
              id="send"
              v-on:click="validate()"
            >
              {{ $t("send") }}
            </button>

            <v-dialog
              id="popup1"
              v-model="dialog"
              width="600"
              class="modal"
              :hide-overlay="true"
              data-app
            >
              <div id="popup1" class="body">
                <div class="header">
                  <img
                    v-on:click="closeDialog()"
                    v-bind:src="'/img/error.svg'"
                    alt="delete"
                  />
                </div>
                <div class="main">
                  <p class="title">{{ $t("inscription-popup.title1") }}</p>
                  <p>{{ company }}</p>
                  <p class="title">{{ $t("inscription-popup.title2") }}</p>
                  <p>{{ $t("inscription-popup.part2", { s: company }) }}</p>
                  <p class="title">{{ $t("inscription-popup.title3") }}</p>
                  <p>{{ $t("inscription-popup.part3") }}</p>
                  <p class="title">{{ $t("inscription-popup.title4") }}</p>
                  <p>{{ $t("inscription-popup.part4") }}</p>
                  <p class="title">{{ $t("inscription-popup.title5") }}</p>
                  <p>{{ $t("inscription-popup.part5") }}</p>
                  <p class="title">{{ $t("inscription-popup.title6") }}</p>
                  <p
                    v-html="
                      $t('inscription-popup.part6', { s: privacy_policy_link })
                    "
                  ></p>
                </div>
              </div>
            </v-dialog>
          </div>
          <!--
                    <div class="box" v-else>
                      <h2>{{$t('thanks.title')}}</h2>
                      <p>{{$t('thanks.message_1')}}</p>
                      <p>{{$t('thanks.message_2')}}</p>
                      <p>{{$t('thanks.message_3')}}</p>
                      <p>{{$t('thanks.message_4')}} <a href="mailto:info@micfootball.com">info@micfootball.com</a> </p>
                      <h6>#WeAreMIC</h6>
                    </div>
                    -->
        </v-layout>
      </v-container>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "Inscripcions",
  components: {
    i18n,
    VueRecaptcha,
  },
  data() {
    return {
      club: {
        name: "",
        address: "",
        cp: "",
        state: "",
        country_id: "",
        phone: "",
        mobile: "",
        email: "",
        web: "",
        city: "",
        phone_aux: "",
        mobile_aux: "",
      },
      contact: {
        name: "",
        surname: "",
        position: "",
        phone: "",
        mobile: "",
        email: "",
        language: "",
        phone_aux: "",
        mobile_aux: "",
      },
      teams: {
        category_types: {},
        modality: false,
        how_meet: "",
      },
      information: false,
      terms_and_conditions: false,
      privacy_policy: false,
      countries: {},
      languages: {},
      how_meet: {},
      contact_type: {},
      error: {
        club: {
          name: false,
          address: false,
          state: false,
          country: false,
          mobile: false,
          email: false,
          invalit_phone: false,
          invalit_mobile: false,
          invalit_email: false,
        },
        contact: {
          name: false,
          surname: false,
          position: false,
          phone: false,
          mobile: false,
          email: false,
          language: false,
          invalit_email: false,
          invalit_phone: false,
          invalit_mobile: false,
        },
        teams: {
          categories: false,
          modality: false,
          how_meet: false,
        },
        terms_and_conditions: false,
        privacy_policy: false,
        recaptcha: false,
        form: false,
      },
      dialog: false,
      lang: "",
      terms_and_conditions_link: "",
      // form_completed: false,
      // event_color: '',
      event_type: "",
      tournament_rules_link: "",
      privacy_policy_link: "",
      company: "",
      // error_popup: false,
      captcha_key: process.env.VUE_APP_CAPTCHA_KEY,
      recaptcha: false,
      bExistsCategoriesBothGender: false,
    };
  },
  created() {
    // get language
    this.$overlay.loading();
    this.lang = this.$route.params.lang;
    // check if isset
    if (!["ca", "es", "en"].includes(this.lang)) {
      this.lang = "ca";
    }
    i18n.loadLanguageAsync(this.lang);
    var self = this;
    // get countries, how_meet and languages
    this.$store
      .dispatch("getInscriptionsInfo", {
        event_id: this.$route.params.event_id,
      })
      .then(function () {
        self.countries = self.$store.getters["getCountries"];
        self.languages = self.$store.getters["getLanguages"];
        self.how_meet = self.$store.getters["getHowMeet"];
        self.contact_type = self.$store.getters["getContactType"];
        // self.event_color            = self.$store.getters['getEventColor'];
        self.event_type = self.$store.getters["getEventType"];
        var category_types = JSON.parse(
          JSON.stringify(self.$store.getters["getCategoryType"])
        );
        var bFoundMasculineGender = false;
        var bFoundFemenineGender = false;
        for (var i in category_types) {
          // check for categories
          if ([1, 3].includes(parseInt(category_types[i].gender))) {
            bFoundMasculineGender = true;
          } else if ([2].includes(parseInt(category_types[i].gender))) {
            bFoundFemenineGender = true;
          }

          category_types[i].checked = false;
          // count for teams
          category_types[i].teams = 1;
          // error variable
          category_types[i].error = false;
        }
        self.bExistsCategoriesBothGender =
          bFoundMasculineGender && bFoundFemenineGender;
        // save categories types
        self.teams.category_types = category_types;

        // save terms and conditions link
        switch (self.event_type) {
          case "MICFootball":
            switch (self.$route.params.lang) {
              case "ca":
                self.terms_and_conditions_link =
                  "https://micfootball.com/wp-content/uploads/2022/05/TERMES-CONDICIONS_MICFootball24-1.pdf?" +
                  moment().valueOf();
                self.tournament_rules_link =
                  "https://micfootball.com/wp-content/uploads/2024/02/MIC-Integra-24_REGLAMENT.pdf";
                self.privacy_policy_link =
                  "https://micfootball.com/ca/politica-de-privacitat/";
                break;
              case "es":
                self.terms_and_conditions_link =
                  "https://micfootball.com/wp-content/uploads/2024/02/MIC-Integra-24_REGLAMENT.pdf?" +
                  moment().valueOf();
                self.tournament_rules_link =
                  "https://micfootball.com/wp-content/uploads/2022/09/REGLAMENTO-MICFootball24.pdf";
                self.privacy_policy_link =
                  "https://micfootball.com/politica-de-privacidad/";
                break;
              case "en":
                self.terms_and_conditions_link =
                  "https://micfootball.com/wp-content/uploads/2024/02/MIC-Integra-24_REGLAMENT.pdf?" +
                  moment().valueOf();
                self.tournament_rules_link =
                  "https://micfootball.com/wp-content/uploads/2022/09/TOURNAMENT-RULES-MICFootball24.pdf";
                self.privacy_policy_link =
                  "https://micfootball.com/en/privacy-policy/";
                break;
            }
            // for popup
            self.company = "AE MICFootball";
            break;
          case "MICFootball7":
            switch (self.$route.params.lang) {
              case "ca":
                self.terms_and_conditions_link =
                  "https://micfootball7.com/wp-content/uploads/2022/11/TERMES-CONDICIONS_MICFootball724.pdf?" +
                  moment().valueOf();
                self.tournament_rules_link =
                  "https://micfootball7.com/wp-content/uploads/2022/11/REGLAMENT_MICFootball724.pdf?" +
                  moment().valueOf();
                self.privacy_policy_link =
                  "http://www.micfootball7.com/ca/politica-de-privacidad";
                break;
              case "es":
                self.terms_and_conditions_link =
                  "https://micfootball7.com/wp-content/uploads/2022/11/TERMINOS-CONDICIONES_MICFootball724.pdf?" +
                  moment().valueOf();
                self.tournament_rules_link =
                  "https://micfootball7.com/wp-content/uploads/2022/11/REGLAMENTO_MICFootball724.pdf?" +
                  moment().valueOf();
                self.privacy_policy_link =
                  "http://www.micfootball7.com/es/politica-de-privacidad";
                break;
              case "en":
                self.terms_and_conditions_link =
                  "https://micfootball7.com/wp-content/uploads/2022/11/TERMS-CONDITIONS_MICFootball724.pdf?" +
                  moment().valueOf();
                self.tournament_rules_link =
                  "https://micfootball7.com/wp-content/uploads/2022/11/TOURNAMENT-RULES_MICFootball724.pdf?" +
                  moment().valueOf();
                self.privacy_policy_link =
                  "http://www.micfootball7.com/en/politica-de-privacidad";
                break;
            }
            // for popup
            self.company = "AE MICFOOTBALL";
            break;
          case "MICBasketball":
            switch (self.$route.params.lang) {
              case "ca":
                self.terms_and_conditions_link =
                  "https://www.micbasketball.com/wp-content/uploads/2019/09/TERMINOS-Y-CONDICIONES-MICBASKETBALL20-CAT.pdf";
                self.tournament_rules_link =
                  "http://www.micbasketball.com/ca/mic18/reglamento/";
                self.privacy_policy_link =
                  "http://www.micbasketball.com/ca/politica-de-privacidad/";
                break;
              case "es":
                self.terms_and_conditions_link =
                  "https://www.micbasketball.com/wp-content/uploads/2019/09/TERMINOS-Y-CONDICIONES-MICBASKETBALL20-ESP.pdf";
                self.tournament_rules_link =
                  "http://www.micbasketball.com/es/mic18/reglamento/";
                self.privacy_policy_link =
                  "http://www.micbasketball.com/es/politica-de-privacidad/";
                break;
              case "en":
                self.terms_and_conditions_link =
                  "https://www.micbasketball.com/wp-content/uploads/2019/09/TERMINOS-Y-CONDICIONES-MICBASKETBALL20-ING.pdf";
                self.tournament_rules_link =
                  "http://www.micbasketball.com/en/mic18/reglamento/";
                self.privacy_policy_link =
                  "http://www.micbasketball.com/en/politica-de-privacidad/";
                break;
            }
            break;
        }

        // default language comunications
        for (let i in self.languages) {
          if (self.lang == self.languages[i].name) {
            self.contact.language = i;
          }
        }

        self.$overlay.hide();
      })
      .catch(() => {
        self.$overlay.hide();
      });
  },
  methods: {
    validate() {
      var validate = true;

      // club

      // validate club name
      if (isEmpty(this.club.name)) {
        this.error.club.name = "clubs.errors.name_empty";
        validate = false;
      } else if (this.club.name.match(/[.,\/#!$%\^&\*;:{}=\-_`~()”“"…]/g)) {
        this.error.club.name = "clubs.errors.name_incorrect";
        validate = false;
      } else {
        this.error.club.name = false;
      }

      // validate club address
      if (isEmpty(this.club.address)) {
        this.error.club.address = true;
        validate = false;
      } else {
        this.error.club.address = false;
      }

      // validate club state
      if (isEmpty(this.club.state)) {
        this.error.club.state = true;
        validate = false;
      } else {
        this.error.club.state = false;
      }

      // validate club country
      if (isEmpty(this.club.country_id)) {
        this.error.club.country = true;
        validate = false;
      } else {
        this.error.club.country = false;
      }

      // club phone
      // check if isset club phone
      if (Object.keys(this.club.phone_aux).length > 0) {
        // validate if phone is valid
        if (this.club.phone_aux.isValid) {
          // ok, save phone
          this.club.phone = this.club.phone_aux.number.e164;
          // remove error
          this.error.club.invalit_phone = false;
          // invalit phone
        } else {
          this.error.club.invalit_phone = true;
          validate = false;
        }
      } else {
        this.error.club.invalit_phone = false;
      }

      // validate club mobile
      if (Object.keys(this.club.mobile_aux).length > 0) {
        // validate if club mobile is valid
        if (this.club.mobile_aux.isValid) {
          // ok save phone
          this.club.mobile = this.club.mobile_aux.number.e164;
          // remove  errors
          this.error.club.mobile = false;
          this.error.club.invalit_mobile = false;
          // invalit mobile number
        } else {
          this.error.club.invalit_mobile = true;
          this.error.club.mobile = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.club.mobile = true;
        validate = false;
      }

      // validate club e-mail
      if (isEmpty(this.club.email)) {
        this.error.club.email = true;
        validate = false;
        // validate email
      } else {
        // valit email
        if (validateEmail(this.club.email)) {
          this.error.club.email = false;
          this.error.club.invalit_email = false;
          // invalit email
        } else {
          validate = false;
          this.error.club.email = true;
          this.error.club.invalit_email = true;
        }
      }

      // contact

      // validate contact name
      if (isEmpty(this.contact.name)) {
        this.error.contact.name = true;
        validate = false;
      } else {
        this.error.contact.name = false;
      }

      // validate last name
      if (isEmpty(this.contact.surname)) {
        this.error.contact.surname = true;
        validate = false;
      } else {
        this.error.contact.surname = false;
      }

      // validate contact position
      if (isEmpty(this.contact.position)) {
        this.error.contact.position = true;
        validate = false;
      } else {
        this.error.contact.position = false;
      }

      // validate contact phone
      if (Object.keys(this.contact.phone_aux).length > 0) {
        // validate if club mobile is valid
        if (this.contact.phone_aux.isValid) {
          // ok save phone
          this.contact.phone = this.contact.phone_aux.number.e164;
          // remove  errors
          this.error.contact.phone = false;
          this.error.contact.invalit_phone = false;
          // invalit mobile number
        } else {
          this.error.contact.invalit_phone = true;
          this.error.contact.phone = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.contact.phone = true;
        validate = false;
      }

      // validate contact mobile
      if (Object.keys(this.contact.mobile_aux).length > 0) {
        // validate if club mobile is valid
        if (this.contact.mobile_aux.isValid) {
          // ok save phone
          this.contact.mobile = this.contact.mobile_aux.number.e164;
          // remove  errors
          this.error.contact.mobile = false;
          this.error.contact.invalit_mobile = false;
          // invalit mobile number
        } else {
          this.error.contact.invalit_mobile = true;
          this.error.contact.mobile = true;
          validate = false;
        }
        // empty mobile
      } else {
        this.error.contact.mobile = true;
        validate = false;
      }

      // validate contact email
      if (isEmpty(this.contact.email)) {
        this.error.contact.email = true;
        validate = false;
        // validate email
      } else {
        // valit email
        if (validateEmail(this.contact.email)) {
          this.error.contact.email = false;
          this.error.contact.invalit_email = false;
          // invalit email
        } else {
          validate = false;
          this.error.contact.email = true;
          this.error.contact.invalit_email = true;
        }
      }

      // validate contact language
      if (isEmpty(this.contact.language)) {
        this.error.contact.language = true;
        validate = false;
      } else {
        this.error.contact.language = false;
      }

      // Teams
      // boolean for check if is checked one category.
      var categoriesChecked = false;
      // validate teams categories
      for (var i in this.teams.category_types) {
        if (this.teams.category_types[i].checked) {
          // a category is checked
          categoriesChecked = true;
          // validate number
          if (parseInt(this.teams.category_types[i].teams) < 1) {
            this.teams.category_types[i].error = true;
            validate = false;
          } else {
            this.teams.category_types[i].error = false;
          }
        }
      }

      // validate if
      if (!categoriesChecked) {
        this.error.teams.categories = true;
        validate = false;
      } else {
        this.error.teams.categories = false;
      }

      // validate teams modality
      //   if (isEmpty(this.teams.modality)) {
      //     this.error.teams.modality = true;
      //     validate = false;
      //   } else {
      //     this.error.teams.modality = false;
      //   }

      // validate teams how meet
      if (isEmpty(this.teams.how_meet)) {
        this.error.teams.how_meet = true;
        validate = false;
      } else {
        this.error.teams.how_meet = false;
      }

      // terms and conditions
      if (!this.terms_and_conditions) {
        this.error.terms_and_conditions = true;
        validate = false;
      } else {
        this.error.terms_and_conditions = false;
      }

      // validate privacy policy
      if (!this.privacy_policy) {
        this.error.privacy_policy = true;
        validate = false;
      } else {
        this.error.privacy_policy = false;
      }

      // try {
      //   // validate recaptcha
      //   if(typeof grecaptcha !== 'undefined' && grecaptcha != null && isEmpty(grecaptcha.getResponse())){
      //     this.error.recaptcha = true;
      //     validate = false;
      //   } else {
      //     this.error.recaptcha = false;
      //   }
      // } catch(error) {
      //     console.log(error);
      //     this.error.recaptcha = false;
      // }

      if (!this.recaptcha) {
        this.error.recaptcha = true;
        validate = false;
      } else {
        this.error.recaptcha = false;
      }

      // add team
      if (validate) {
        var self = this;
        this.$overlay.loading();
        // club join to event
        this.$store
          .dispatch("joinTournament", {
            event_id: self.$route.params.event_id,
            // club
            txt_nombre_club: self.club.name,
            txt_direccion: self.club.address,
            txt_cp: self.club.cp,
            txt_state: self.club.state,
            txt_pais: self.club.country_id,
            txt_localidad: self.club.city,
            txt_telefono: self.club.phone,
            txt_movil: self.club.mobile,
            txt_email: self.club.email,
            txt_web: self.club.web,
            // contact
            txt_nombre_responsable: self.contact.name,
            txt_apellidos_responsable: self.contact.surname,
            sel_cargo_resp: self.contact.position,
            txt_telefono_resp: self.contact.phone,
            txt_movil_resp: self.contact.mobile,
            txt_email_resp: self.contact.email,
            sel_lang: self.languages[self.contact.language].name,
            chk_recibir: self.information ? 1 : 0,
            // teams
            categories: JSON.stringify(self.teams.category_types),
            check_Estancia: 2, //self.teams.modality == "true" ? 1 : 2,
            sel_como: self.teams.how_meet,
          })
          .then(function (response) {
            // redirect to greating page
            window.top.location = self.$store.getters["getRedirectPage"];
            self.$overlay.hide();
          })
          .catch(() => {
            self.$overlay.hide();
          });
      } else {
        this.error.form = true;
        // this.scrollToErrors();
        // this.error_popup = true;
      }
    },

    openDialog() {
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
    },

    /*
      closePopup() {
          this.error_popup = false;
      },
      */
    /*
      scrollToErrors(){
        let aux = document.getElementsByClassName('error');

        if ( aux[0] ) {
          var scroll = {
            container: document.getElementById('inscripcion'),
            target: aux[0],
            offset: -100,
          };
          this.$root.scrollTo(scroll);
        }
      },
      */

    clubPhone(input, oResult) {
      this.club.phone_aux = oResult;
    },

    clubMobile(input, oResult) {
      this.club.mobile_aux = oResult;
    },

    contactPhone(input, oResult) {
      this.contact.phone_aux = oResult;
    },

    contactMobile(input, oResult) {
      this.contact.mobile_aux = oResult;
    },
  },

  computed: {
    team_total() {
      var total = 0;
      for (var i in this.teams.category_types) {
        if (this.teams.category_types[i].checked) {
          total += parseInt(this.teams.category_types[i].teams);
        }
      }
      return total;
    },

    cssProps() {
      return {
        "background-color": this.$store.getters["getEventColor"],
      };
    },

    cssButton() {
      return {
        background: this.$store.getters["getEventColor"],
      };
    },

    event_color() {
      return this.$store.getters["getEventColor"];
    },
  },

  /*
    updated(){
      let aux = Object.values(this.error);

      // club
      if(Object.values(aux[0]).indexOf(true) != -1) {

        this.scrollToErrors();

      // contact
      } else if (Object.values(aux[1]).indexOf(true) != -1) {

        this.scrollToErrors();

      // teams
      } else if (Object.values(aux[2]).indexOf(true) != -1) {

        this.scrollToErrors();

      }
    }
    */
};
</script>

<style lang="scss">
// iframe
body {
  // overflow: hidden;
}

body::-webkit-scrollbar {
  width: 0;
}

body::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

body::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
}
.application--wrap {
  width: 100%;
}

#inscripcion-app {
  .error-form {
    margin: 0 auto;
    display: block;
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }

  background-color: #fff;
  margin: 0;
  padding: 5px;
  height: 100%;

  hr {
    background-color: #ccc;
    margin: 30px auto;
    width: 95%;
    background-color: transparent;
  }

  h2,
  h3,
  h4,
  h6 {
    font-family: AvantGarde-Bold;
    color: $main-color !important;
    text-transform: uppercase;
  }

  h3 {
    font-size: 24px;
    background: #172654;
    color: #fff !important;
    padding: 4px;
  }

  h6 {
    font-size: 18px;
    background: #eee;
    color: #999 !important;
    padding: 8px;
  }

  .alert {
    background-color: #e5faff;
    padding: 15px;
    width: 98%;
    margin: 20px auto;
    font-size: 16px;
  }

  .container.fluid.grid-list-md {
    padding: 0;
  }

  #top-description {
    text-align: center;

    h3 {
      font-family: AvantGarde-Bold;
      text-align: center;
    }

    .description {
      margin: 0 auto;
      display: inline-block;
      p {
        text-align: justify;
        text-justify: inter-word;
        font-family: AvantGarde-Bold;
      }
    }
  }

  #inscripcion {
    h2 {
      text-align: center;
      text-transform: uppercase;
      font-style: italic;
      font-family: AvantGarde-Bold;
    }

    a {
      text-decoration: underline;
      cursor: pointer;
      font-weight: bold;
      font-family: AvantGarde-Bold;
    }

    .info {
      p,
      h4 {
        text-align: center;
        font-family: AvantGarde-Bold;
      }
    }

    .box {
      width: 100%;
      margin: 0 auto;
      height: auto;
      overflow: auto;
      text-align: center;
      font-family: AvantGarde-Bold;

      // background-color: var(--event_color);

      .message.error {
        color: $warning-color;
        // font-family: AvantGarde-Bold;
      }

      label {
        font-family: AvantGarde-Bold;
        font-size: 14px;
        margin-bottom: 3px;
        // padding: 0;
        // margin-bottom: 5px;
        display: block;
        color: black;
        font-weight: bold;
      }

      .item {
        width: calc(50% - 40px);
        margin: 10px 20px;
        display: inline-block;

        input,
        select,
        .v-autocomplete .v-input__slot {
          width: 100%;
          padding: 5px 6px;
          margin-bottom: 0;
          border: 1px solid $main-color;
          outline: none;
          font-size: 11pt;
          border-radius: 3px;
          color: $dark-color;
          font-family: Roboto-Light;
          font-weight: lighter;

          &::placeholder {
            color: $dark-color;
            font-family: Roboto-Light;
            font-weight: lighter;
            // opacity: 0;
          }

          &.shadow:focus {
            border-color: #66afe9;
            outline: 0;
            border-left: 6px solid #66afe9;
            // -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
            // box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102,175,233,.6);
          }
        }

        .v-autocomplete {
          margin-top: 0;
          padding-top: 0;
          font-family: AvantGarde-Bold;
          .v-input__control {
            font-family: AvantGarde-Bold;
            .v-input__slot {
              margin: 0;
              padding: 0;

              &:after,
              &:before {
                content: "";
                border: none !important;
                font-family: AvantGarde-Bold;
              }
            }
            .v-select__slot {
              border: none;
              font-family: AvantGarde-Bold;
              // padding: 5px 12px;
              padding: 0;
              input {
                border: none;
                margin: 0;
              }
            }
          }
        }

        .error {
          border-color: red !important;
          // font-family: AvantGarde-Bold;
          &::placeholder {
            color: $alert-color !important;
            opacity: 1;
            // font-family: AvantGarde-Bold;
          }
          .v-input__slot {
            border-color: $alert-color;
            // font-family: AvantGarde-Bold;
          }
          .vti__input {
            border-color: red !important;
          }
        }

        .upper {
          text-transform: uppercase;
          // font-family: AvantGarde-Bold;
          // &::placeholder {
          //   text-transform: none;
          //   font-family: AvantGarde-Bold;
          // }
        }

        span {
          color: black;
          font-size: 16px;
          // font-weight: bold;
          // font-family: AvantGarde-Bold;
        }
      }

      .categories {
        vertical-align: top;

        .v-input--is-label-active {
          // border-left: 5px solid #ccc;

          // & {
          //   border-left: 5px solid #ccc;
          // }

          span {
            font-weight: bold;
            font-family: AvantGarde-Bold;
          }
        }

        .v-input--is-label-active + .teams {
          font-family: AvantGarde-Bold;
        }

        .v-input__slot,
        .v-label {
          margin: 0;
        }

        input {
          display: inline-block;
          width: 100%;
        }
        .text {
          display: inline-block;
          width: 100%;
          margin: 0;
        }

        .teams {
          display: inline-block;
          vertical-align: top;
          margin-bottom: 25px;

          .teams_number_description {
            width: auto;
            display: inline-block;
            margin-right: 10px;
          }
          .teams_number {
            width: 40px;
            display: inline-block;
            text-align: center;
          }
        }
      }

      input[type="number"] {
        -moz-appearance: textfield;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }

      select {
        background-image: url("/img/sort-down.svg");
        background-size: 10px;
        background-position: right 10px center;
        background-repeat: no-repeat;
        font-family: AvantGarde-Bold;
      }

      select option {
        font-size: 14pt;
      }

      #send {
        max-width: 300px;
        width: 100%;
        padding: 15px;
        outline: none;
        border: none;
        cursor: pointer;
        font-size: 12pt;
        font-family: AvantGarde-Bold;
        margin-top: 5px;
        border-radius: 3px;
        border: 1px solid $secondary-color;
        text-transform: uppercase;
        transition: all 0.5s;
        background: $main-color;
        color: $secondary-color;

        &:hover {
          background: #222 !important;
        }
      }
    }

    .obligatory {
      color: $alert-color !important;
      font-weight: bold;
      // font-family: AvantGarde-Bold;
    }

    .v-input__slot {
      margin: 0;
    }

    /*
      .checkbox, .description {
        display: inline-block;
        padding: 0;
        margin: 0;
      }

      .checkbox {
        width: auto;
        // width: 25px;
        border: 1px solid red;
      }

      .description {
        vertical-align: middle;
        margin-left: 10px;
      }
      */
  }

  .terms_and_conditions {
    margin: 0;
    display: inline-block;
  }

  .information {
    border: 1px solid $secondary-color;
    margin-left: 10px;
    padding: 10px;
  }

  .form-subtitle {
    margin-top: 36px;

    &:first-of-type {
      margin-top: 12px;
    }
  }

  @media (max-width: 720px) {
    #inscripcion {
      .box {
        .item {
          width: calc(100% - 20px);
        }
      }
    }
  }
}

#popup1 {
  height: auto;
  background-color: white;
  padding: 20px;

  .header {
    margin-bottom: 50px;
    // border-bottom: 1px solid $secondary-color;

    img {
      width: 25px;
      height: 25px;
      float: right;
      margin: 10px;
      cursor: pointer;
    }
  }

  .main {
    .title {
      margin: 10px 0;
    }

    p {
      margin: 0;
      margin-bottom: 20px;
      // font-family: AvantGarde-Bold;
    }
  }

  a {
    text-decoration: underline;
    cursor: pointer;
    font-weight: bold;
    font-family: AvantGarde-Bold;
  }
}

@include media(">phone", "<tablet") {
  /*
    .categories {
      vertical-align: top;
       .text, span {
        display: block;
        width: 100%;
        text-align: center;
      }
    }
    .teams_number {
        display: block !important;
        margin: 0 auto !important;
        text-align: center !important;
        width: 50% !important;
    }
    */
  .teams {
    display: block !important;
    text-align: center;
    margin: 0 auto;
  }

  .item {
    margin: 0 !important;
  }
}
</style>
